let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iaw3j")).then(() => parcelRequire('ajCgx'));